// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/main.css'
// 导入ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 导入axios
import axios from 'axios'
// 导入echarts
import * as echarts from 'echarts'
//导入全局变量
import global from './global/global'
import Print from "vue-print-nb";

// vue中导出excel表格模板
import FileSaver from 'file-saver'  
import XLSX from 'xlsx'
// 将excel表格模板设置全局
Vue.prototype.$FileSaver = FileSaver; 
Vue.prototype.$XLSX = XLSX; 

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)



require('./mock');

Vue.config.productionTip = false
ElementUI.Dialog.props.lockScroll.default = false;
Vue.use(ElementUI);
Vue.prototype.$axios = axios
Vue.prototype.$echarts = echarts
Vue.prototype.global = global
Vue.use(Print) // 注册

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js